import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import swal from 'sweetalert2';
import moment from 'moment';

const AddCost = ({isShow, productTypeList, saveFunc, toggleFunc}) => {
  //const { reason} = productTypeList || [];
  const [dropReason, setDropReason] = useState('1');
  const [itemName, setItemName] = useState('');
  const [transactionDate, setTransactionDate] = useState(moment().format('YYYY-MM-DD'));
  const [amount, setAmount] = useState(0);
  const [supplier, setSupplier] = useState('');
  const [notes, setNotes] = useState('');
  const handleDropReason = (e) => {
    setDropReason(e.target.value)

  }
  function containsChinese(str) {
    return /[\u4E00-\u9FAF]/.test(str);
}
    return (
      <div className="u-editblock fadeIn" style={{display: isShow === true ? 'flex' : 'none'}}>
        <div className="form-block" style={{minWidth: '400px'}}>
          <div className="u-small-title">新增成本</div>
          <form className="u-form">
          <div className="row">
                      <div className="col-5 col-pad-12">
                        <select className="u-form__select" style={{marginLeft:'5px',marginTop:'8px'}} value={dropReason} onChange={handleDropReason}>
                        {
                            productTypeList.map((item)=>{
                                return <option key={item.id} value={item.id}>{item.name}</option>
                            })
                        }
                        </select>
                      </div>
                    </div>
            <div className="row m-t-16">
              <div className="col-12 col-pad-12">
                <label className="u-form__label text-align-right">名稱：</label>
                <input required={true} value={itemName} onChange={(e)=>{setItemName(e.target.value);}} className="u-form__input underline"/>
              </div>
            </div>
            <div className="col-6 col-pad-12">
                      <label className="u-form__label text-align-right" style={{flex: '0 0 54px'}}>日期：</label>
                      <DatePicker
                        locale="zh-tw"
                        placeholderText="請選擇日期"
                        dateFormat="YYYY-MM-DD"
                        autoComplete="off"
                        className="u-form__input"
                        selected={moment(transactionDate)}
                        onChange={(e) => {
                            setTransactionDate(e.format('YYYY-MM-DD'))
                        }}
                        selectsStart
                      />
                    </div>
            <div className="row m-t-16">
              <div className="col-12 col-pad-12">
                <label className="u-form__label text-align-right">金額：</label>
                <input type='number'  required={true} value={amount} onChange={(e)=>{setAmount(e.target.value);}} className="u-form__input underline"/>
              </div>
            </div>
            <div className="row m-t-16">
              <div className="col-12 col-pad-12">
                <label className="u-form__label text-align-right">供應商：</label>
                <input value={supplier} onChange={(e)=>{setSupplier(e.target.value);}} className="u-form__input underline"/>
              </div>
            </div>
            <div className="row m-t-16">
              <div className="col-12 col-pad-12">
                <label className="u-form__label text-align-right">備註：</label>
                <input value={notes} onChange={(e)=>{setNotes(e.target.value);}} className="u-form__input underline"/>
              </div>
            </div>
            <div className="u-btn-group right">
              <button className="btn btn-md save" onClick={(e) => {
                e.preventDefault();
                if(itemName.length == 0){
                    alert('請填寫名稱')
                    return
                }
                if(amount == 0){
                    alert('請填寫金額')
                    return
                }
                saveFunc(dropReason,itemName,transactionDate,amount,supplier,notes);
                setItemName('')
                setNotes('')
                setAmount(0)
                setSupplier('')
                setTransactionDate(moment().format('YYYY-MM-DD'))
                setDropReason('1')
              }}>送出</button>
              <button className="btn btn-md cancel m-l-16" onClick={
                (e) => {
                  e.preventDefault();
                  setItemName('')
                  setTransactionDate(moment().format('YYYY-MM-DD'))
                  setAmount(0)
                  setNotes('')
                  setSupplier('')
                  setDropReason('1')
                  toggleFunc();
                }
              }>取消</button>
            </div>
          </form>
        </div>
      </div>
    )

  }

export default AddCost;